module.exports = __webpack_public_path__ + "static/media/icon_botebasura18px.fa07c8a1.svg";